const mergeObject = (src, obj) => {
    if (typeof src != 'object' || typeof obj != 'object') return;

    for (const key in obj) {
        if (typeof obj[key] == 'object') {
            if (!src[key]) {
                src[key] = {};
            }
            src[key] = mergeObject(src[key], obj[key]);
        } else {
            src[key] = obj[key];
        }
    }
    return {...src};
};

export default mergeObject;